import { omitBy, isNil, isEmpty, isUndefined, find, compact } from "lodash";
import statesCities from "Components/profile/profile-details/addresses/country_MY.json";
import { useEffect } from "react";
import CryptoJS from "crypto-js";

import {
  CustomerCompanyFormInputType,
  PhoneFormatPayload,
  PhoneType,
} from "src/types/customer-form.types";

const model = (data: CustomerCompanyFormInputType) => {
  const phonesFormatter = (adminNo: PhoneType, officeNo: PhoneType) => {
    const arr: PhoneFormatPayload[] = [];
    if (adminNo) {
      arr.push({
        countryCode: adminNo.dialCode,
        number: adminNo.number,
        fullNumber: `${adminNo.dialCode}${adminNo.number}`,
        type: "MOBILE",
      });
    }
    if (officeNo && !isEmpty(officeNo?.number)) {
      arr.push({
        countryCode: officeNo.dialCode,
        number: officeNo.number,
        fullNumber: `${officeNo.dialCode}${officeNo.number}`,
        type: "OFFICE",
      });
    }
    return arr;
  };

  const workingHourFormatter = () => {
    let formattedWorkingHours = data?.workingHours?.map((current) => {
      if (current?.isChecked)
        return {
          day: current?.day,
          openingTime: current?.openingTime,
          closingTime: current?.closingTime,
        };
    });

    return compact(formattedWorkingHours);
  };

  return omitBy(
    {
      org: omitBy(
        {
          _id: data._id ? data._id : undefined,
          name: !isEmpty(data.customerName) ? data.customerName : undefined,
          orgType: data.orgType,
          primaryEmail: !isEmpty(data.emailAddress)
            ? data.emailAddress
            : undefined,
          website: !isEmpty(data.companyWebsite)
            ? data.companyWebsite
            : undefined,
          primaryPhone: {
            countryCode: data.contactNo.dialCode,
            number: data.contactNo.number,
            fullNumber: `${data.contactNo.dialCode}${data.contactNo.number}`,
            type: "MOBILE",
          },
          contact: {
            fullName: data.contactPerson,
            email: data.adminEmailAddress,
            phones: phonesFormatter(data.adminContactNo, data.officeContactNo),
          },
          regNo: data.businessRegistrationNumber,
          workingHours: workingHourFormatter(),
          customerType: data.customerType,
          prefix: data.prefix,
          customerOrderTypes: data?.parcelTypes,
          allowPickupAll: data?.allowPickupAll
        },
        (value) => isUndefined(value),
      ),
      superAdminPassword: data.password
        ? CryptoJS.SHA256(data.password).toString(CryptoJS.enc.Hex)
        : undefined,
      parentOrgID: data._id
        ? undefined
        : data.parentOrgID
        ? data.parentOrgID
        : undefined,
      location: omitBy(
        {
          primary: true,
          _id: data.locationID ? data.locationID : undefined,
          orgName: data.customerName,
          coordinate: data.coordinates,
          address: omitBy(
            {
              street1: data.street1,
              street2: data.street2 ? data.street2 : undefined,
              city: data.city,
              cityCode: find(
                find(
                  statesCities.STATES,
                  (element) => data.state === element.NAME,
                )?.CITIES,
                (element) => element.NAME === data.city,
              )?.CODE,
              state: data.state,
              stateCode: find(
                statesCities.STATES,
                (element) => data.state === element.NAME,
              )?.CODE,
              postcode: data.postcode,
              country: data.country,
            },
            (value) => isUndefined(value),
          ),
          workingHours: workingHourFormatter(),
          orgType: data.orgType,
          contactPerson: !isEmpty(data.customerName)
            ? data.customerName
            : undefined,
          contactNumber: {
            countryCode: data.contactNo.dialCode,
            number: data.contactNo.number,
            fullNumber: `${data.contactNo.dialCode}${data.contactNo.number}`,
            type: "MOBILE",
          },
        },
        (value) => isUndefined(value),
      ),
      file: !isEmpty(data.file)
        ? data.file?.file_url
          ? undefined
          : data.file
        : undefined,
    },
    (value) => isUndefined(value),
  );
};

export default model;
